exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warning[data-v-0627c157]{margin:36px 0 54px;padding:0 42px;line-height:1.5;font-family:Open Sans,sans-serif}.warning__header[data-v-0627c157]{margin-bottom:18px;font-size:16px;font-weight:600;text-transform:uppercase;color:rgba(0,0,0,.85)}.warning__text[data-v-0627c157]{margin-bottom:18px;font-size:16px;font-weight:400;color:rgba(0,0,0,.75)}.warning__data[data-v-0627c157]{font-size:14px;color:rgba(0,0,0,.75)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0627c157","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/warning/Warning.vue
// module id = 9448f8eb579b11a7051a
// module chunks = 8